<template>
  <v-row dense align="end">
    <v-col cols="auto">
      <v-radio-group hide-details row v-model="spDataType" @change="onSpDataTypeChange">
        <v-radio v-if="tool.spFileChoose" label="文件上传" :value="1"></v-radio>
        <v-radio v-if="tool.spTextInput" label="文本输入" :value="2"></v-radio>
        <v-radio v-if="tool.spEx" label="使用示例文件" :value="3"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="auto">
      <!-- 示例文件是否为压缩包？ -->
      <a @click="onDownSpExFile">下载示例文件</a>
    </v-col>
    <v-col cols="12" class="mt-2">
      <v-form ref="analyseSpForm">

        <template v-if="inputType==1">
          <v-file-input :accept="acceptFiles" single-line :label="dataFileLabel" v-model="spDataFile" @change="onSpDataFileChanged" :rules="spDataFileRule" outlined dense prepend-icon="" append-icon="mdi-paperclip" @click:append="(e)=>e.target.parentNode.parentNode.parentNode.children[1].children[2].click()" />
          <v-file-input single-line :label="groupFileLabel" v-model="spGroupDataFile" :rules="spGroupDataFileRule" outlined dense prepend-icon="" append-icon="mdi-paperclip" @click:append="(e)=>e.target.parentNode.parentNode.parentNode.children[1].children[2].click()" />
        </template>

        <template v-else-if="inputType==2">
          <v-file-input :accept="acceptFiles" single-line :label="dataFileLabel" v-model="spDataFile" :error="spDataFileError" :error-messages="spDataFileErrorMessages" @change="onSpDataFileChanged" :rules="spDataFileRule" outlined dense prepend-icon="" append-icon="mdi-paperclip" @click:clear="onSpDataFileClear" @click:append="(e)=>e.target.parentNode.parentNode.parentNode.children[1].children[2].click()" />
        </template>

        <template v-else-if="inputType==3">
          <v-textarea single-line v-model="spDataText" placeholder="请参考右侧示例输入样本数据" :rules="spDataTextRule" outlined dense @keydown.native="onSpDataTextKeydown"></v-textarea>
          <v-textarea single-line v-model="spGroupDataText" placeholder="请参考右侧示例输入样本分组数据" :rules="spDataTextRule" outlined dense @keydown.native="onSpGroupDataTextKeydown"></v-textarea>
        </template>

        <template v-else-if="inputType==4">
          <v-textarea single-line v-model="spDataText" placeholder="请参考右侧示例输入样本数据" :rules="spDataTextRule" outlined dense @keydown.native="onSpDataTextKeydown"></v-textarea>
        </template>

        <!-- venn多组数据输入(不用考虑分组数据) -->
        <template v-else-if="inputType==5">
          <venn-data-editor ref="vennDataEditor" v-model="spDataText" :max="vennMax"></venn-data-editor>
        </template>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
/* eslint-disable no-console */

import { required, fileType, EXP_ANALYSE_CONTENT } from '@/plugins/rules';
import { downloadToolExample } from '@/plugins/api';
import XLSX from 'xlsx';

export default {
  props: ['tool'],
  data () {
    return {
      // dataFileLabel: `请选择数据文件[${this.tool.spFileTypes}]`,
      spDataType: 1,
      spDataText: '',
      spDataFile: null,
      spGroupDataFile: null,
      spGroupDataText: '',
      rules: { fileType: fileType(this.tool.spFileTypes) },

      spDataFileErrorMessages: [],
      spDataFileError: false
    }
  },
  computed: {
    dataFileLabel() {
        let tip = "请选择数据文件";
        if(this.tool.code == 'TCM_NetWork'){
          tip = "请输入化合物文件";
        }
        return `${tip}[${this.tool.spFileTypes}]`;
    },
    groupFileLabel () {
      if(this.tool.code == 'TCM_NetWork') {
        return "请输入疾病数据文件";
      }
      return this.tool.code == 'wgcna' ? '请选择表型文件' : '请选择数据分组文件';
    },
    spDataFileRule () {
      return this.spDataType == 1 ? [required(), fileType(this.tool.spFileTypes)] : [];
    },
    acceptFiles () {
      let types = [];
      let spTypes = this.tool.spFileTypes.split(',');
      spTypes.forEach(t => types.push(`.${t}`));
      return types.join(',');
    },
    spGroupDataFileRule () {
      let ret = [];
      if (this.spDataType != 1) return ret;
      if (this.tool.spGroupRequired) ret.push(required());
      ret.push(fileType(this.tool.spFileTypes));
      return ret;
    },
    spDataTextRule () {
      return this.spDataType == 2 ? [required()] : [];
    },
    inputType () {
      let type = this.spDataType;
      let b1 = this.tool.spFileChoose, b2 = this.tool.spTextInput, b3 = this.tool.spGroup, b4 = this.tool.spTextInputMulti;
      if (type == 1 && b1 && b3) return 1; // 数据文件与分组文件上传
      else if (type == 1 && b1 && !b3) return 2; // 仅上传数据文件
      else if (type == 2 && b2 && b3 && !b4) return 3; // 数据文本与分组文本输入
      else if (type == 2 && b2 && !b3 && !b4) return 4; // 仅输入数据文本
      else if (type == 2 && b2 && b4) return 5; // venn专用
      return 0;
    },
    vennMax () {
      return this.tool.spTextInputMax;
    }
  },
  methods: {
    onDownSpExFile () {
      downloadToolExample(this.tool.id);
    },
    onSpDataFileClear () {
      this.spDataFileError = true;
      this.spDataFileErrorMessages = ['此项为必填项'];
    },
    async onSpDataFileChanged (e) {
      if (!e) return true;
      let filename = e.name;
      if (filename.endsWith('xlsx')) {
        this.$store.commit('showLoading')
        let fileReader = new FileReader();
        fileReader.onload = (ev) => {
          let data = ev.target.result;
          let workbook = XLSX.read(data, { type: 'binary' });
          let wsname = workbook.SheetNames[0]; // 取第一张表
          // let ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]); // 生成json表格内容
          // let ws = XLSX.utils.sheet_to_slk(workbook.Sheets[wsname]) // 输出表格对应位置是什么值
          // let ws = XLSX.utils.sheet_to_html(workbook.Sheets[wsname]) // 生成HTML输出
          // let ws = XLSX.utils.sheet_to_csv(workbook.Sheets[wsname]) // 生成分隔符分隔值输出
          // let ws = XLSX.utils.sheet_to_formulae(workbook.Sheets[wsname]) // 生成公式列表（具有值回退）
          // let content = XLSX.utils.sheet_to_txt(workbook.Sheets[wsname]); // 生成UTF16格式的文本
          let content = XLSX.utils.sheet_to_csv(workbook.Sheets[wsname], { FS: '\t' }); // 生成UTF16格式的文本
          if (!content) {
            this.spDataFileError = true;
            this.spDataFileErrorMessages = ['文件内容不能为空'];
          } else {
            this.validateContent(content);
          }
          this.$store.commit('hideLoading')
        }
        fileReader.readAsBinaryString(e);
      } else {
        let fileReader = new FileReader()
        fileReader.onload = (ev) => {
          let content = ev.target.result;
          this.validateContent(content);
        }
        fileReader.readAsText(e);
      }
    },
    validate () {
      let ret = this.$refs.analyseSpForm.validate();
      if (!ret) return false;
      let vennDataEditor = this.$refs.vennDataEditor;
      if (vennDataEditor && !vennDataEditor.validate()) return false;
      return (this.inputType == 1 || this.inputType == 2) ? !this.spDataFileError : ret;
    },
    onSpDataTextKeydown (e) {
      if (e.keyCode == 9) {
        this.spDataText += '\t';
        e.returnValue = false;
      }
    },
    onSpGroupDataTextKeydown (e) {
      if (e.keyCode == 9) {
        this.spGroupDataText += '\t';
        e.returnValue = false;
      }
    },
    onSpDataTypeChange () {
      this.$refs.analyseSpForm.resetValidation();
    },
    getBillData () {
      let ret = new FormData();
      ret.append('spDataType', this.spDataType);
      if (this.spDataType == 1) {
        ret.append('spDataFile', this.spDataFile);
        if (this.tool.spGroup) ret.append('spGroupDataFile', this.spGroupDataFile);
      } else if (this.spDataType == 2) {
        ret.append('spDataText', this.spDataText);
        if (this.tool.spGroup) ret.append('spGroupDataText', this.spGroupDataText);
      }
      return ret;
    },
    validateContent (content) {
      let rows = content.trim().split('\n');
      let emptyRows = [], errorRows = [];
      rows.slice(0, rows.length - 1).forEach((row, index) => {
        let rs = row.replaceAll('\t', '').trim();
        if (!rs) emptyRows.push(index + 1);
        else if (!EXP_ANALYSE_CONTENT.test(rs)) errorRows.push(index + 1);
      })
      if (emptyRows.length || errorRows.length) {
        this.spDataFileError = true;
        let msg = '';
        if (emptyRows.length) {
          msg += '(文件内容存在空行:' + emptyRows.join(',') + ')';
        }
        if (errorRows.length) {
          msg += '(文件内容格式有误:' + errorRows.join(',') + ')';
        }
        this.spDataFileErrorMessages = [msg];
      } else {
        this.spDataFileError = false;
        this.spDataFileErrorMessages = [];
      }
    }
  },
  components: {
    VennDataEditor: () => import('./Editor/VennDataEditor.vue')
  }
}
</script>